import React from "react";
import { cartExampleImages } from "../../data/cartImagesObj";
import { processString } from "../../assets/js/custom";

const MainCartModal = ({ activeCartData }) => {
  const showCartData = (item, ind) => {
    if (item.type === "heading") {
      return (
        <div key={ind} className="mb-3 mb-lg-4">
          <h4 key={ind} className="cart-modal-head">
            {item?.content}
          </h4>
        </div>
      );
    } else if (item.type === "para") {
      return (
        <div key={ind} className="mb-3">
          <div className="cart-modal-sub-head">{item?.dataHeader}</div>
          {item?.content.length > 0 &&
            item?.content.map((val, i) => (
              <p className="cart-modal-para" key={i}>
                {val}
              </p>
            ))}
        </div>
      );
    } else if (item.type === "sources") {
      return (
        <div key={ind} className="mb-3 cart-modal-content-wrapper">
          <div className="cart-modal-sub-head">{item?.dataHeader}</div>
          <div className="cart-modal-sources">
            {item?.content.map((val, i) => (
              <div className="cart-image-wrapper" key={i}>
                <div className="img-wrapper">
                  <img src={cartExampleImages[processString(val)]} alt="" />
                </div>
                <span key={i}>{val}</span>
              </div>
            ))}
          </div>
        </div>
      );
    } else if (item.type === "list") {
      return (
        <div key={ind} className="mb-3 cart-modal-content-wrapper">
          <div className="cart-modal-sub-head">{item?.dataHeader}</div>
          <ul className="cart-modal-list">
            {item?.content.map((val, i) => (
              <li key={i}>{val}</li>
            ))}
          </ul>
        </div>
      );
    } else if (item.type === "link") {
      return (
        <div key={ind} className="mb-3 cart-modal-content-wrapper">
          <div className="cart-modal-sub-head">{item?.dataHeader}</div>
          <div className="cart-modal-links">
            {item?.content.map((val, i) => (
              <a
                key={i}
                href={val.body}
                target="_blank"
                rel="noopener noreferrer"
              >
                {val.head}
              </a>
            ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="modal fade cart-modal"
      id="cartModal"
      tabIndex="-1"
      aria-labelledby="cartModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" tabIndex="0">
            <div className="modal-heading">{activeCartData?.header}</div>
            {Object.keys(activeCartData).length > 0 &&
              activeCartData?.data.map((item, i) => showCartData(item, i))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainCartModal;
